import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { Iheader } from '../../interfaces/StoreTypes';

type SearchOverlayType = {
    type: string;
    payload: boolean;
};

const headerSlice = createSlice({
    name: 'Header',
    initialState: initialState.header,
    reducers: {
        openSearchInputOverlay: (state: Iheader, action: SearchOverlayType) => {
            state.searchOverlay = action.payload;
        },
        closeSearchInputOverlay: (state: Iheader, action: SearchOverlayType) => {
            state.searchOverlay = action.payload;
        },
    },
});

export const { openSearchInputOverlay, closeSearchInputOverlay } = headerSlice.actions;

export default headerSlice.reducer;
